<script>
  let element;

  const adjustHeight = () =>
    (element.style.height = `${element.scrollHeight}px`);

  // Grow the text input as typing occurs
  const onInput = () => adjustHeight();

  // Adjust height when backspace is clicked
  const onBackspace = e => {
    const key = e.keyCode || e.charCode;

    if (key == 8 || key == 46) {
      element.style.height = "var(--defaultHeight)";
      adjustHeight();
    }
  };
</script>

<style>
  textarea {
    --defaultHeight: 25px;
    border: 0.5px solid white;
    border-radius: 1rem;
    font-size: 0.8rem;
    height: var(--defaultHeight);
    overflow: hidden;
    padding: 0 1rem;
    resize: none;
    /* width: 90%; */
  }

  textarea:focus {
    outline: none;
  }
</style>

<textarea
  bind:this={element}
  class="clear-element flex-1"
  maxlength="240"
  on:input={onInput}
  on:keydown={onBackspace} />
